import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeInterview: null,
  upcomingInterviews: [],
  completedInterviews: [],
  openInterviewModal: false,
  resumeUrl: "",
};

const studentPageSlice = createSlice({
  name: "studentpage",
  initialState,
  reducers: {
    setResume(state, action) {
      state.resumeUrl = action.payload;
    },
    setInterviewModal(state, action) {
      state.openInterviewModal = action.payload;
    },
    setActiveInterview(state, action) {
      state.activeInterview = action.payload;
    },
    setUpcomingInterviews(state, action) {
      state.upcomingInterviews = action.payload;
    },
    appendUpcomingInterviews(state, action) {
      state.upcomingInterviews = [...state.upcomingInterviews, ...action.payload];
    },
    setCompletedInterviews(state, action){
      state.completedInterviews = action.payload;
    },
    appendCompletedInterviews(state, action) {
      state.completedInterviews = [...state.completedInterviews, ...action.payload];
    },
    updateInterviewResume(state, action) {
      const { interviewIndex, resumeUrl } = action.payload;
      if (state.upcomingInterviews[interviewIndex]) {
        state.upcomingInterviews[interviewIndex].resume_url = resumeUrl;
      }
    },
  },
});

const { actions, reducer: studentPageReducer } = studentPageSlice;
export const {
  setActiveInterview,
  setUpcomingInterviews,
  appendUpcomingInterviews,
  setCompletedInterviews,
  appendCompletedInterviews,
  setResume, 
  setInterviewModal,
  updateInterviewResume
} = actions;

export default studentPageReducer;
